import { useState } from 'react';
import { DataLoader } from './auth/DataLoader';
import { PackingApp } from './app/PackingApp';
import { ActivationModal } from './components/ActivationModal';

function getActivateToken() {
  const params = new URLSearchParams(window.location.search);
  return params.get('activate');
}

function App() {
  const [activateToken, setActivateToken] = useState(() => getActivateToken());

  const handleActivationDone = () => {
    // Remove ?activate= from URL and go to normal login
    window.history.replaceState({}, '', window.location.pathname);
    setActivateToken(null);
  };

  if (activateToken) {
    return <ActivationModal token={activateToken} onDone={handleActivationDone} />;
  }

  return (
    <DataLoader>
      {({ user, onLogout, defaults }) => (
        <PackingApp
          user={user}
          onLogout={onLogout}
          defaultProducts={defaults.products}
          defaultUnitTypes={defaults.unitTypes}
          defaultCountries={defaults.countries}
          defaultGuidelines={defaults.guidelines}
          defaultSavedAddresses={defaults.savedAddresses}
          defaultCustomProducts={defaults.customProducts}
        />
      )}
    </DataLoader>
  );
}

export default App;
